<template>
    <div>
        <Panel title="连接池查询">
            <template slot="buttons">
                <el-button title="查询" class="blue" icon="el-icon-fa-search" @click="pageTable.handleLoad()">查询</el-button>
                <el-button title="重置" class="yellow" icon="el-icon-fa-refresh" @click="pageTable.handleReset()">重置</el-button>
            </template>
            <el-form :model="pageTable.param" ref="queryForm">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="cn_name" label="连接池名称">
                            <el-input v-model="pageTable.param.cn_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="cn_defn" label="连接池标识">
                            <el-input v-model="pageTable.param.cn_defn"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="连接池列表">
            <template slot="buttons">
                <el-button title="导入" class="green" icon="el-icon-fa-download" @click="handleImport">导入</el-button>
                <el-button title="导出" class="blue" icon="el-icon-fa-upload" @click="handleExport">导出</el-button>
                <el-button title="添加" class="green" icon="el-icon-fa-plus" @click.stop="doAdd">添加</el-button>
                <el-button title="删除" class="red" icon="el-icon-fa-trash" @click="doSeleDel">删除</el-button>
            </template>

            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                      ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 271px)">
                <el-table-column prop="$rownum" label="NO." width="50" align="center"/>
                <el-table-column type="selection" align='center' width="50"></el-table-column>
                <el-table-column prop="cnname" label="连接池名称" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="cndefn" label="连接池标识" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="ptname" label="连接池类型" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="cnpoolsize" label="池大小" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="POOLSIZE_USED" label="配置连接数" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="NUM_ACTIVE" label="运行实例数" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="{row}">
                        <el-button title="编辑连接池" class="blue" @click="doEdit(row)" icon="el-icon-fa-edit">编辑
                        </el-button>
                        <el-button title="删除连接池" class="red" @click="doDelete(row)" icon="el-icon-fa-trash">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable width="800px" :visible.sync="editor.show" title="连接池编辑">
            <div class="dialog-button">
                <el-button title="测试连接池" class="green" v-loading="editor.loading" icon="el-icon-warning" @click="doCheckConn()">测试
                </el-button>
                <el-button title="保存连接池" class="blue" v-loading="editor.loading" icon="el-icon-fa-save" @click="doSubmit()">保存</el-button>
            </div>
            <div v-if="editor.show" v-loading="editor.loading">
                <ConnEditor :uuid="editor.uuid"
                            @loading="v => editor.loading = v"
                            v-model="editor.data"
                            ref="ConnEditorRef"
                            @refresh="()=>{pageTable.handleLoad(); editor.show = false;}"></ConnEditor>
            </div>
        </el-dialog>

        <el-dialog append-to-body v-draggable title="导入连接池" :visible.sync="upload.visible" width="500px">
            <ConnImport @upd='()=>{upload.visible = false; pageTable.handleLoad();}' v-if="upload.visible"></ConnImport>
        </el-dialog>
    </div>
</template>

<script>
import ConnApi from "./Conn";
import ConnEditor from "./ConnEditor";
import { PageTable } from 'cnetong-core-frontend';
import ConnImport from "./ConnImport.vue";

export default {
    name: "Conn",
    components: {ConnEditor, ConnImport},
    data() {
        return {
            pageTable: new PageTable({
                doLoad: ConnApi.queryConnList,
                autoLoad: true
            }),
            editor: {
                show: false,
                uuid: null,
                visible: false,
                loading: false,
                data: {}
            },
            multipleSelection: [], // 批量操作数组
            upload: {
                visible: false
            }
        };
    },
    methods: {
        // 批量删除
        async doSeleDel() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning("请选择数据！");
                return;
            }
            await this.confirm();
            await ConnApi.delConn(this.multipleSelection.map(v => v.uuid));
            this.pageTable.handleLoad();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 打开连接池编辑页面
        doEdit(rowData) {
            this.editor.data = rowData;
            this.editor.uuid = rowData.uuid;
            this.editor.show = true;
        },
        // 删除
        async doDelete(rowData) {
            try {
                await this.confirm();
                this.pageTable.isLoading = true;
                this.editor.uuid = rowData.uuid;
                await ConnApi.delConn([rowData.uuid])
                this.pageTable.handleLoad();
            } finally {
                this.pageTable.isLoading = false;
            }
        },
        // 保存
        async saveConn(data) {
            this.editor.loading = true;
            if (data.uuid) {
                await ConnApi.updateConn(data);
            } else {
                await ConnApi.saveConn(data);
            }
            this.cancelEditorLoading();
            this.pageTable.handleLoad();
        },
        // 取消加载
        cancelEditorLoading() {
            this.editor.show = false;
            this.editor.loading = false;
        },
        doSubmit() {
            this.$refs.ConnEditorRef.submitForm();
        },
        doCheckConn() {
            this.$refs.ConnEditorRef.checkConn();
        },
        doAdd() {
            this.editor.uuid = null;
            this.editor.show = true;
            this.dataConn = null;
        },

        handleImport() {
            this.upload.visible = true;
        },
        async handleExport() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning("请选择数据！");
                return;
            }

            await this.confirm();
            let array = this.multipleSelection.map(v => v.uuid);
            let resp = await ConnApi.connExport(array);
            let eleLink = document.createElement('a');
            eleLink.download = "导出连接池.json";
            eleLink.style.display = 'none';

            let blob = new Blob([resp.data]);
            eleLink.href = URL.createObjectURL(blob);
            document.body.appendChild(eleLink);
            eleLink.click();
            document.body.removeChild(eleLink);
        },
    }
};
</script>
